import View     from '@widesk-ui/components/View';
import useTheme from '@widesk-ui/hooks/useTheme';

export default function RequestErrorMessage(props: { text: string; request?: string }) {
	const theme = useTheme();

	return (
		<View inline left>
			{props.text}
			{props.request && <View size="small" color={theme.colorTextDescription}>{props.request}</View>}
		</View>
	);
}
